export { CopilotAssistant } from './CopilotAssistant'
export type { CopilotAssistantProps, TimelineItem } from './types'
export { getTimestampMs } from './types'
